import Headroom from "headroom.js";

const mainHeader = document.querySelector('.main-header');

if (mainHeader !== null) {
  const headRoomHeaderOptions = {
    offset: mainHeader.clientHeight,
  };

  const headRoomHeader = new Headroom(mainHeader, headRoomHeaderOptions);
  headRoomHeader.init();

  const mainContent = document.querySelector('main');

  const resizeObserver = new ResizeObserver(() => {
    mainContent.style.paddingTop = `${mainHeader.clientHeight}px`;
  });

  resizeObserver.observe(mainHeader);

}
